import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Marker } from '@outdoria/types';
import { fetcher } from '../utils';
import { ADMIN_MARKER_UPDATE, MARKER, ADMIN_MARKERS_ALL } from '../queryKeys';

export const useAdminUpdateMarker = (marker_id: string) => {
  const queryClient = useQueryClient();

  const mutationFn = async (
    marker: Omit<Marker, 'marker_id'>,
  ): Promise<void> => {
    const response = await fetcher(`/v2/admin/markers/${marker_id}`, {
      method: 'PUT',
      body: JSON.stringify(marker),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (response.status !== 204)
      throw new Error(
        (await response.json()).error ??
          'Could not update the marker for some unforeseen reason!',
      );
    queryClient.invalidateQueries({ queryKey: ADMIN_MARKERS_ALL });
    queryClient.invalidateQueries({
      queryKey: MARKER,
      exact: false,
    });
  };

  const { mutate, error, status, isPending, isSuccess, isError } = useMutation({
    mutationKey: ADMIN_MARKER_UPDATE,
    mutationFn,
  });

  return { mutate, error, status, isPending, isSuccess, isError };
};
